import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { EmailErrorMessage } from '@core/services/user/user.model';
import { emailFormatValidator } from '@shared/directives/email-format.directive';

@Component({
  selector: 'Teranet-ForgetPassword',
  templateUrl: './forget-password.component.html',
})
export class ForgetPasswordComponent implements OnInit {
  emailAddress: string;
  emailErrorMessage = EmailErrorMessage;
  errorMessage: string;
  forgetPasswordForm: FormGroup;
  isError: boolean = false;

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.forgetPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, emailFormatValidator]),
    });
  }

  onCancel() {
    this.router.navigate(['login']);
  }

  onSubmit() {
    this.isError = false;
    this.errorMessage = null;
    if (this.forgetPasswordForm.valid) {
      this.authService.checkEmail(this.emailAddress).subscribe(() => {
        this.localStorageService.setItem('recoveryUser', this.emailAddress);
        this.router.navigateByUrl('/passwordrecoveryquestion');
      },
        (err: HttpErrorResponse) => {
          this.isError = true;
          this.errorMessage = err.error;
        }
      );
    }
  }
}
